import { Button, Flex, LoadingOverlay, TextInput } from '@mantine/core';
import { drawerTransitionProps } from '@dealstack/frontend/shared/mechanism/styleguide/GlobalStyling.tsx';
import {
	FormField,
	StyledDrawer,
} from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/MasterDocuments/styles.ts';
import { MipClassifierRes } from '@dealstack/shared/lib/generated';
import { useManageClassifierDrawer } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/Classifiers/components/ManageClassifierDrawer/useManageClassifierDrawer.ts';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';

interface Props {
	opened: boolean;
	onClose: () => void;
	classifier: MipClassifierRes | null;
	onSave: (data: { mipClassifierId?: string; name: string }) => void;
	isLoading?: boolean;
}

export const ManageClassifierDrawer = ({
	opened,
	onClose,
	classifier,
	onSave,
	isLoading = false,
}: Props) => {
	const tMipManage = useTranslationMipManage();
	const { name, setName, handleSave, isFormValid, isEditMode } = useManageClassifierDrawer({
		opened,
		classifier,
		onSave,
	});

	const drawerTitle = isEditMode
		? tMipManage('root.classifiers.drawer.title.edit')
		: tMipManage('root.classifiers.drawer.title.add');
	const submitButtonText = isEditMode
		? tMipManage('root.classifiers.drawer.button.save')
		: tMipManage('root.classifiers.drawer.button.add');

	return (
		<StyledDrawer
			opened={opened}
			onClose={onClose}
			position="right"
			size="md"
			transitionProps={drawerTransitionProps}
			title={drawerTitle}
		>
			<Flex direction="column" h="100%" mih={400}>
				<LoadingOverlay visible={isLoading} overlayProps={{ blur: 2 }} />

				<div style={{ flex: 1 }}>
					<FormField>
						<TextInput
							label={tMipManage('root.classifiers.drawer.label.name')}
							placeholder={tMipManage('root.classifiers.drawer.placeholder.name')}
							size="md"
							required
							value={name}
							maxLength={120}
							onChange={(e) => setName(e.target.value)}
							disabled={isLoading}
						/>
					</FormField>
				</div>

				<Flex direction="column" align="flex-start" gap="1rem" mt="auto">
					<Button
						fullWidth
						onClick={handleSave}
						disabled={!isFormValid || isLoading}
						loading={isLoading}
					>
						{submitButtonText}
					</Button>
				</Flex>
			</Flex>
		</StyledDrawer>
	);
};
